var map = {
	"./个体货主.png": 4229,
	"./冷链运输.png": 4808,
	"./制造企业.png": 1401,
	"./危化品运输.png": 4891,
	"./商贸企业.png": 7906,
	"./城市配送.png": 6807,
	"./大宗商品运输.png": 9406,
	"./干线运输.png": 444,
	"./混凝土运输.png": 2557,
	"./渣土运输.png": 402,
	"./电商平台.png": 9283,
	"./零担运输.png": 446
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2794;